module.exports = __webpack_public_path__ + "img/edit-config.35c8a0d1.svg";